export const TARGET_DIMENSIONS = {
  WIDTH: 400,
  HEIGHT: 300,
}
